import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { TargetSelector, getSettingValueSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import { connect } from "react-redux";
import { setVariantId } from "../../actions";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  const productIdSelector = getSettingValueSelector(TargetSelector.Entity, "product");
  const productVariantIdSelector = getSettingValueSelector(TargetSelector.Entity, "productVariant");

  return (state: AppState, props: RootContainerProps): MapProps => {
    return {
      productVariantId: productVariantIdSelector(state, props),
      productId: productIdSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  setVariantId: (id: string | null) => dispatch(setVariantId(getEntityRef(props), id))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
